import { useState } from "react";
import { motion } from "framer-motion";
import { FiMail, FiPhone, FiMapPin, FiSend } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import contactHero from "../assets/contact-hero.jpg";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailto = `mailto:gophoenixdatasolutions@gmail.com?subject=${encodeURIComponent(form.subject)}&body=${encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\n\n${form.message}`
    )}`;
    window.location.href = mailto;
  };

  return (
    <>
      <HeroBanner
        image={contactHero}
        title="Contact Us"
        subtitle="Let's build your digital future together. Whether you need powerful software or scalable digital marketing, we're ready."
      />

      <SectionWrapper>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <h2 className="section-title mb-6">Get In <span className="text-primary">Touch</span></h2>
            <p className="text-muted-foreground font-roboto mb-8">
              Fill out the form below and our team will get back to you within 24 hours.
            </p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <input
                  type="text"
                  placeholder="Your Name"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border border-border bg-muted font-roboto text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all"
                />
                <input
                  type="email"
                  placeholder="Your Email"
                  required
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border border-border bg-muted font-roboto text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border border-border bg-muted font-roboto text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all"
                />
                <input
                  type="text"
                  placeholder="Subject"
                  required
                  value={form.subject}
                  onChange={(e) => setForm({ ...form, subject: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border border-border bg-muted font-roboto text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all"
                />
              </div>
              <textarea
                placeholder="Your Message"
                required
                rows={5}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full px-4 py-3 rounded-lg border border-border bg-muted font-roboto text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all resize-none"
              />
              <button type="submit" className="btn-primary flex items-center gap-2">
                <FiSend className="w-4 h-4" /> Send Message
              </button>
            </form>
          </motion.div>

          {/* Contact Info */}
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <h2 className="section-title mb-6">Contact <span className="text-primary">Info</span></h2>
            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <FiMapPin className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h4 className="font-montserrat font-bold mb-1">Our Address</h4>
                  <p className="text-muted-foreground font-roboto text-sm">
                    CWEP1641, Compass Building, Al Shohada Road, AL Hamra Industrial Zone-FZ, Ras Al Khaimah, United Arab Emirates
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <FiMail className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h4 className="font-montserrat font-bold mb-1">Email Us</h4>
                  <a href="mailto:gophoenixdatasolutions@gmail.com" className="text-primary font-roboto text-sm hover:underline">
                    gophoenixdatasolutions@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <FiPhone className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h4 className="font-montserrat font-bold mb-1">Call Us</h4>
                  <a href="tel:+971585791239" className="text-primary font-roboto text-sm hover:underline">
                    +971 58 579 1239
                  </a>
                </div>
              </div>
            </div>

            {/* Map placeholder */}
            <div className="rounded-xl overflow-hidden shadow-lg border border-border">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3600.6!2d55.79!3d25.68!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDQwJzQ4LjAiTiA1NcKwNDcnMjQuMCJF!5e0!3m2!1sen!2sae!4v1"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="GoPhoenix Location"
              />
            </div>
          </motion.div>
        </div>
      </SectionWrapper>
    </>
  );
};

export default Contact;